import * as React from 'react';

export class Divider extends React.Component<{}, {}> {
    render() {
        return (
            <div style={{
                width: 1,
                height: 40,
                backgroundColor: '#d9d9d9',
                margin: '4px 12px 4px 0'
            }} />
        );
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/module/section/components/toolbar/Divider.tsx
 **/